import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (payload: { nome: string; descricao?: string; visibilidade: 'privado' | 'equipe' | 'contrato' }) => void;
  isSaving: boolean;
}

export const SaveTemplateDialog: React.FC<Props> = ({ open, onClose, onSave, isSaving }) => {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [visibilidade, setVisibilidade] = useState<'privado' | 'equipe' | 'contrato'>('privado');

  const handleSave = () => {
    if (!nome.trim()) return;
    onSave({ nome: nome.trim(), descricao: descricao.trim() || undefined, visibilidade });
    setNome(''); setDescricao('');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Salvar relatório</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="nome-template">Nome *</Label>
            <Input
              id="nome-template"
              value={nome}
              onChange={e => setNome(e.target.value)}
              placeholder="Ex.: Relatório mensal de obras"
              maxLength={120}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="desc-template">Descrição</Label>
            <Textarea
              id="desc-template"
              value={descricao}
              onChange={e => setDescricao(e.target.value)}
              rows={2}
              placeholder="Opcional..."
              maxLength={300}
            />
          </div>
          <div className="space-y-1.5">
            <Label>Visibilidade</Label>
            <Select value={visibilidade} onValueChange={v => setVisibilidade(v as typeof visibilidade)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="privado">🔒 Privado (somente eu)</SelectItem>
                <SelectItem value="equipe">👥 Equipe do contrato</SelectItem>
                <SelectItem value="contrato">📋 Todos no contrato</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} disabled={!nome.trim() || isSaving}>
            {isSaving ? 'Salvando…' : 'Salvar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
